// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2610) return "static/chunks/2610.06ad6f0c8374696e.js";
	if (chunkId === 6472) return "static/chunks/6472.2d0941ad25a6b43d.js";
	if (chunkId === 2672) return "static/chunks/2672.56178a2327b0e421.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"844":"ee560e2c","2202":"eec3d76d","6711":"8e1d74a4","8087":"0e762574"}[chunkId] || chunkId) + "-" + {"844":"de25152fc1a348c6","2202":"eb17c9b5e60406ed","2651":"62f9235d935785cd","5565":"f70505dda5ef90e8","6711":"cb776eba11ed49f5","8087":"53be2849197da197","8173":"86bddb51b006f995"}[chunkId] + ".js";
};